import React, { FunctionComponent, useState } from 'react'
import { connect } from 'react-redux'
import LoaderButton from '../../../components/loaderButton'
import TradelineOptionCard from './tradelineOptionCard'
import { Callback } from '../../../utils/types'
import { selectCurrentRefi, selectCurrentRefiUser } from '../../../reducers'
import {
  updateRefi,
  setRefiAppSelectedTradelineIndex,
  setRefiAppCreditStepState,
} from '../refiActions'
import { Refi } from '../types'
import { User } from '../../../core/types'

export interface Props {
  setRefiAppSelectedTradelineIndex: Callback
  setRefiAppCreditStepState: Callback
  updateRefi: Callback<Promise<any>>
  refi: Refi
  user: User
}

export const SelectTradeline: FunctionComponent<Props> = ({
  setRefiAppSelectedTradelineIndex,
  updateRefi,
  setRefiAppCreditStepState,
  refi,
}) => {
  const [selectedTradelineIndex, setSelectedTradelineIndex] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const handleClick = () => {
    setIsLoading(true)
    const loanDetails = {
      id: refi.id,
      current_loan_tradeline_index: selectedTradelineIndex,
    }

    updateRefi(loanDetails).then(
      () => {
        setRefiAppSelectedTradelineIndex(selectedTradelineIndex)
        setRefiAppCreditStepState('LoanOverviewComponent')
      },
      () => {
        setIsLoading(false)
      }
    )
  }

  return (
    <div>
      <div className="tradeline-selection-card-container">
        {refi.open_tradelines && refi.open_tradelines.length > 0 ? (
          refi.open_tradelines.map((tradeline) => (
            <TradelineOptionCard
              key={tradeline.tradeline_index}
              data={tradeline}
              onSelect={() =>
                setSelectedTradelineIndex(tradeline.tradeline_index)
              }
              selected={selectedTradelineIndex === tradeline.tradeline_index}
            />
          ))
        ) : (
          <span>No tradelines available</span>
        )}
      </div>
      <div style={{ marginTop: '2rem' }}>
        <div className="form__group filter__buttons">
          <LoaderButton
            type="button"
            className="button button-drive-america"
            data-testid="selectTradelineNext"
            onClick={handleClick}
            disabled={!selectedTradelineIndex}
            isLoading={isLoading}
          >
            Next
          </LoaderButton>
        </div>
      </div>
    </div>
  )
}

export const mapStateToProps = (state) => ({
  refi: selectCurrentRefi(state),
  user: selectCurrentRefiUser(state),
})

export default connect(mapStateToProps, {
  setRefiAppSelectedTradelineIndex,
  updateRefi,
  setRefiAppCreditStepState,
})(SelectTradeline)
